"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

var Tabs_1 = __importDefault(require("react-bootstrap/Tabs"));

var Tab_1 = __importDefault(require("react-bootstrap/Tab"));

require("./SzTab.scss");

var SzTab = function SzTab(_a) {
  var id = _a.id,
      className = _a.className,
      activeKey = _a.activeKey,
      selectTabHandle = _a.selectTabHandle,
      children = _a.children;
  return react_1.default.createElement(Tabs_1.default, {
    id: id,
    className: className,
    activeKey: activeKey,
    onSelect: selectTabHandle
  }, children);
};

var SzTabContent = function SzTabContent(props) {
  return react_1.default.createElement(Tab_1.default, __assign({}, props), react_1.default.createElement("div", {
    className: "mt-5"
  }, props.children));
};

SzTab.SzTabContent = SzTabContent;
SzTab.propTypes = {
  id: prop_types_1.default.string,
  className: prop_types_1.default.string,
  activeKey: prop_types_1.default.string,
  selectTabHandle: prop_types_1.default.func,
  children: prop_types_1.default.node
};
SzTab.SzTabContent.propTypes = {
  title: prop_types_1.default.string,
  children: prop_types_1.default.node
};
exports.default = SzTab;